import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  page: {
    flexDirection: "column",
    flex: 1,
    backgroundColor: "white",
    padding: 15,
  },
  container: {},
  pictureContainer: {
    display: "flex",
    flexDirection: "row",
  },
  timestamp: {
    flex: 1,
    fontSize: 12,
  },
  contentContainer: {
    marginTop: 15,
  },
});
